import React from 'react';
import DealMetrics from './analytics/DealMetrics';
import PredictiveAnalytics from './analytics/PredictiveAnalytics';
import { useDeals } from '../store/DealsContext';

export default function Dashboard() {
  const { deals } = useDeals();

  return (
    <div className="space-y-6">
      <DealMetrics />
      
      <div className="bg-white p-6 rounded-lg shadow-sm">
        <h2 className="text-xl font-bold text-gray-800 mb-6">Predictive Analytics</h2>
        <PredictiveAnalytics />
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Recent Deals</h3>
          <div className="space-y-4">
            {deals.slice(0, 5).map((deal) => (
              <div key={deal.id} className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-900">{deal.name}</p>
                  <p className="text-sm text-gray-500">{deal.status}</p>
                </div>
                <p className="text-sm font-medium text-gray-900">
                  {new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    notation: 'compact',
                    maximumFractionDigits: 1
                  }).format(deal.value)}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Deal Pipeline Overview</h3>
          <div className="space-y-4">
            {[
              { stage: 'Prospect', count: deals.filter(d => d.status === 'prospect').length },
              { stage: 'Due Diligence', count: deals.filter(d => d.status === 'due_diligence').length },
              { stage: 'Negotiation', count: deals.filter(d => d.status === 'negotiation').length },
              { stage: 'Closing', count: deals.filter(d => d.status === 'closing').length }
            ].map((stage) => (
              <div key={stage.stage} className="flex items-center justify-between">
                <span className="text-sm font-medium text-gray-900">{stage.stage}</span>
                <div className="flex items-center">
                  <div className="w-32 h-2 bg-gray-200 rounded-full mr-2">
                    <div
                      className="h-2 bg-blue-600 rounded-full"
                      style={{
                        width: `${(stage.count / deals.length) * 100}%`
                      }}
                    />
                  </div>
                  <span className="text-sm text-gray-600">{stage.count}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}